<template>
    <md-table class="az-table">
        <md-table-row v-if="headers">
            <md-table-cell v-if="primary" class="title" :rowspan="getRowSpan" width="15%">{{primary}}</md-table-cell>
            <md-table-cell v-for="(item, index) in headers" :key="index" class="gray">{{headers[index]}}</md-table-cell>
        </md-table-row>
        <md-table-row v-for="(row, index) in dataFormated" :key="index" :class="getClass(index)" >
            <md-table-cell v-for="(cell, key) in row" :key="key" >{{cell}}</md-table-cell>
        </md-table-row>
    </md-table>
    
</template>

<script>
export default {
    name: 'az-table',
    props:['headers','data','primary'],
    computed: {
        getRowSpan() {
            // falta calcular
            return 10;
        },
        lastIndex() {
            return this.data[0].length-1;
        },
        dataFormated() {
            let dataClone = [];
            for (let key in this.data){
                let copy = this.data[key].slice(0);
                copy.pop();
                dataClone[key] = copy;
            }
            return dataClone;

        }
    },
    methods: {
        
        getClass(index) {
            if (this.data[index][this.lastIndex] == 1)
                return 'gray';
            return ''
        }
    }
}
</script>
<style>
.az-table{
    border:1px solid #ddd;
    max-height: 400px;
    overflow: hidden;

}
.az-table .title{
    font-weight: bold;
    text-align: center;
    border-right: 1px solid #ddd;
}
.az-table .gray{
    background-color: #ddd;
    font-weight: bold;
}

.az-table .md-table-cell{
    padding: 3px;
    font-size:12px;
    height: 10px;
}

</style>
